import { forwardRef, useCallback } from 'react';
import type { ReactNode } from 'react';

import { Textfield } from '@simplywallst/ui-core';

import { StyledTextfieldWrapper } from './styled';

interface Props {
  name: string;
  prefix?: ReactNode;
  value: string;
  onChange: (value: string) => void;
}

export const HoldingInput = forwardRef<HTMLInputElement, Props>(function Input(
  { value, prefix, onChange, name },
  ref
) {
  const handleChange = useCallback(
    (event) => {
      const { value } = event.target;
      onChange(value);
    },
    [onChange]
  );

  const handleFocus = useCallback((event) => {
    event.target.select();
  }, []);

  return (
    <StyledTextfieldWrapper>
      <Textfield
        ref={ref}
        styleType="standardReverse"
        name={name}
        type="text"
        prefix={prefix}
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        inputMode="decimal"
        pattern="[0-9]*"
      />
    </StyledTextfieldWrapper>
  );
});
